import styled from "styled-components";

const Container = styled.div`
  > * {
    margin-right: 8px;
    margin-bottom: 8px;
  }
`;

export { Container };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/ActiveFiltersStyle.js